import 'css-chunksrc/client/scenes/planzoneResourceToProject/resourceToProjectForm/resourceSelection/selectedResourcesList/styles.scss';export default {
  "selectedResourcesList": "_selectedResourcesList_mb877_1",
  "button": "_button_mb877_10"
};